import ApiService from "@/common/api.service";
import pdf from 'vue-pdf'
import interact from "interactjs";
import { SET_LOADING, SET_SNACKBAR } from "@/store/mutations.type";
export default {
    methods: {
      async editCertificateBox(slug, data){
        this.editCertificateStatus = true
        await ApiService.get(slug+data.temp_id).then(resp => {
          this.cert_link = this.getPdf(resp.data.data)
          this.cert_meta_data = JSON.parse(data.temp_meta_data)
          let font_meta_data = JSON.parse(data.font_meta_data)
          this.fontsize = font_meta_data["font-size"]
          this.selectedFont = font_meta_data.font
          for (var key in this.cert_meta_data) {
              this.cert_meta_data[key].forEach((data,index) => {
                this.cert_meta_data[key][index].positionX = (data.positionX*3.7795275591)
                this.cert_meta_data[key][index].positionY = (data.positionY*3.7795275591)
              })
          }
          let loadingTask = pdf.createLoadingTask(this.cert_link);
  
          loadingTask.promise.then(pdf => { 
              this.pageCount = pdf.numPages 
          });
  
          this.pdfDragSetup()
          this.renderizzaPlaceholder(this.currentPage)
  
          this.$store.commit(SET_LOADING, false)
        })
      },
      async handlePreview (slug, id){
        ApiService.get(slug+'?temp_file_id='+id).then(resp => {
            let fileURL = this.getPdf(resp.data.data);
            window.open(fileURL);
            this.$store.commit(SET_LOADING, false)
          });
      },
      renderizzaEditPlaceholder(paramsData){

        let parametri = paramsData
              
        let htmlData = ''      
        for (let i = 0; i < parametri.length; i++) {
          let param = parametri[i];
    
    
          let classStyle = "";
          classStyle = "drag-drop can-drop";
          htmlData+= '<div class="'+classStyle+'" data-id="'+param.id+'" data-desc="'+param.fieldName+'" data-x="'+((param.positionX/this.pxtomm)+240 -6)+'" data-y="'+((param.positionY/this.pxtomm))+'" style="transform: translate('+((param.positionX/this.pxtomm)+240-6)+'px, '+((param.positionY/this.pxtomm))+'px); ">  <span class="circle"></span><span class="descrizione">'+param.fieldName+' </span></div>'
          }
          this.$nextTick(()=>{
            document.getElementById('parametriContainer').innerHTML= htmlData
          })
        },
        pdfDragSetup(){
            interact('.drag-drop')
            .draggable({
            inertia: true,
            restrict: {
              restriction: "#selectorContainer",
              endOnly: true,
              elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
            },
            autoScroll: true,
            // dragMoveListener from the dragging demo above
            onmove: function (event) {
              var target = event.target,
              x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
              y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
              target.style.webkitTransform =
              target.style.transform ='translate(' + x + 'px, ' + y + 'px)';
              target.setAttribute('data-x', x);
              target.setAttribute('data-y', y);
              }
            });
    
            interact('.dropzone').dropzone({
              accept: '.drag-drop',
              overlap: 1,
              ondropactivate: function (event) {
                event.target.classList.add('drop-active');
              },
              ondragenter: function (event) {
                var draggableElement = event.relatedTarget,
                dropzoneElement = event.target;
                dropzoneElement.classList.add('drop-target');
                draggableElement.classList.add('can-drop');
                draggableElement.classList.remove('dropped-out');
              },
              ondragleave: function (event) {
                event.target.classList.remove('drop-target');
                event.relatedTarget.classList.remove('can-drop');
                event.relatedTarget.classList.add('dropped-out');
              },
              ondropdeactivate: function (event) {
                event.target.classList.remove('drop-active');
                event.target.classList.remove('drop-target');
              }
            });
       },
       async updateCertification(){
        if (this.$refs.certificationform.validate()) {
          let formData = new FormData(document.getElementById("certificationform"))
          this.getCoordinates(this.currentPage);
          if(this.cert_meta_data.length == 0){
            this.certificationerror = {'Fields': 'Please drop fields on PDF'}
            return;
          }
          let certmetadata = JSON.parse(JSON.stringify( this.cert_meta_data));
          for (var key in certmetadata) {
              certmetadata[key].forEach((data,index) => {
                certmetadata[key][index].positionX = data.positionX*this.pxtomm
                certmetadata[key][index].positionY = data.positionY*this.pxtomm
              })
          }
          let font_meta_data= {"font": this.selectedFont, "font-variant": this.fontValues.find(o => o.value === this.selectedFont).variant, "font-size": this.fontsize};
          this.$store.commit(SET_LOADING, true)
   
          formData.set("temp_meta_data", JSON.stringify(certmetadata));
          formData.set('temp_id', this.temp_id)  
          formData.set('font_meta_data', JSON.stringify(font_meta_data));
          formData.set('temp_validity', this.temp_validity);
          formData.set('temp_file_id', this.temp_file_id);
          formData.set('_method','put')
          
          ApiService.post(this.updateSlug+'/'+this.temp_id, formData).then( resp => {
            if(resp.data.success !== undefined && resp.data.success){
                this.$store.dispatch(this.getData,this.temp_id).then(tempresp=>{
                  if(tempresp.success !== undefined && tempresp.success){
                    this.$store.commit(SET_SNACKBAR, {status: true, message: 'Template updated successfully'})
                    this.$store.commit(SET_LOADING, false)
                    this.closeCertificationBox()
                  }
                  else {
                    this.$store.commit(SET_LOADING, false)
                  }
                })
            }
            else{
              this.$store.commit(SET_LOADING, false)
            }
          })
        }
      },
       renderizzaPlaceholder(newValue){
    
        let parametri = this.dragValues
        let yCounterOfGenerated = 0;
        let numOfMaxItem = 25;
        let notValidHeight = 30;
        let y = 0;
        let x = 6;
              
        let htmlData = ''      
        for (let i = 0; i < parametri.length; i++) {
          let param = parametri[i];
          
          if(i > 0 && i%numOfMaxItem == 0){
            yCounterOfGenerated = 0;
          }
    
          let classStyle = "";
          y = yCounterOfGenerated;
          yCounterOfGenerated += notValidHeight;
          classStyle = "drag-drop dropped-out";
          if(this.cert_meta_data['0'+(newValue)] !== undefined && this.cert_meta_data['0'+(newValue)].findIndex(o =>o.id == param.id) > -1){
            let index = this.cert_meta_data['0'+(newValue)].findIndex(o => o.id == param.id)
            let classStyleIn = 'drag-drop can-drop'
            let fieldName = this.cert_meta_data['0'+(newValue)][index].fieldName
            let label = this.cert_meta_data['0'+(newValue)][index].label != undefined || this.cert_meta_data['0'+(newValue)][index].label != null ? this.cert_meta_data['0'+(newValue)][index].label : ''
            let id = this.cert_meta_data['0'+(newValue)][index].id
            let x = this.cert_meta_data['0'+(newValue)][index].positionX
            let y = this.cert_meta_data['0'+(newValue)][index].positionY
            htmlData+='<div class="'+classStyleIn+'" data-id="'+id+'" data-label="'+label+'" data-desc="'+fieldName+'" data-x="'+(x+240)+'" data-y="'+(y)+'" style="transform: translate('+(x+240)+'px, '+(y)+'px); ">  <span class="circle"></span><span class="descrizione">'+fieldName+' '+(label.length>0 ? ' ('+label+')' : '' )+' </span></div>'
          }else{
            htmlData+= '<div class="'+classStyle+'" data-label="'+(param.label != undefined ? param.label : '')+'" data-id="'+param.id+'" data-desc="'+param.fieldName+'" data-x="'+x+'" data-y="'+y+'" style="transform: translate('+x+'px, '+y+'px); ">  <span class="circle"></span><span class="descrizione">'+param.fieldName+' '+(param.label !=undefined ? ' ('+param.label+')' : '' )+' </span></div>'
          }
          }
          this.$nextTick(()=>{
            document.getElementById('parametriContainer').innerHTML= htmlData
          })
    
        },
        getCoordinates (pageCountValue) {
          this.cert_meta_data['0'+(pageCountValue)] = []
          let paramContainerWidth = document.getElementById("parametriContainer").offsetWidth
          document.getElementsByClassName('drag-drop can-drop').forEach((element) =>{
            let x = parseFloat(element.getAttribute('data-x'));
            let y = parseFloat(element.getAttribute('data-y'));
            let id = parseFloat(element.getAttribute('data-id'));
            let label = element.getAttribute('data-label');
            let descrizione = element.getAttribute('data-desc');
            let posizioneY = y;	  
            let posizioneX = (x - paramContainerWidth);
            let val = {"id":  id , "fieldName": descrizione , "label": label ,"positionX":posizioneX,   "positionY":posizioneY, value: '' };
            if(this.cert_meta_data['0'+(pageCountValue)] !== undefined){
              let index = this.cert_meta_data['0'+(pageCountValue)].findIndex(o =>o.id == id)
              if(index > - 1){
                this.cert_meta_data['0'+(pageCountValue)][index] = val
              }
              else{
                this.cert_meta_data['0'+(pageCountValue)].push(val);
              }
            } else {
              this.cert_meta_data['0'+(pageCountValue)]=[val]
            }
          })
        },
        closeCertificationBox(){
          this.$refs.certificationform.resetValidation()
          this.$refs.certificationform.reset()    
          interact('.dropzone').unset()  
          interact('.drag-drop').unset()
          this.cert_file = ''
          this.cert_link = ''
          this.cert_id = ''
          this.selectedFont = ''
          this.fontsize = ''
          this.editCertificateStatus = false
          this.cert_meta_data = null
          this.certificationerror = {}
          this.closeBox()
        },
        getPdf(pdfData){
          let byteCharacters = atob(pdfData);
          let byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], { type: 'application/pdf;base64' });
          let fileURL = URL.createObjectURL(file);
          return fileURL;
        },
        async preview(){
          let formData = new FormData(document.getElementById("certificationform"))
          this.getCoordinates(this.currentPage);
          
          if(Object.keys(this.cert_meta_data).length == 0){
            this.certificationerror = {'Fields': 'Please drop fields on PDF'}
            return;
          }
          if(this.selectedFont == null){
            this.certificationerror = {'Fields': 'Please select font'}
            return;
          }
          if(this.fontsize == null){
            this.certificationerror = {'Fields': 'Please select font size'}
            return;
          }
          let certmetadata = JSON.parse(JSON.stringify(this.cert_meta_data));
          for (var key in certmetadata) {
              certmetadata[key].forEach((data,index) => {
                certmetadata[key][index].positionX = data.positionX*this.pxtomm
                certmetadata[key][index].positionY = data.positionY*this.pxtomm
              })
          }
          let font_meta_data= {"font": this.selectedFont, "font-variant": this.fontValues.find(o => o.value === this.selectedFont).variant, "font-size": this.fontsize};
          formData.set("temp_meta_data", JSON.stringify(certmetadata));
          formData.set('font_meta_data', JSON.stringify(font_meta_data));
          if(this.temp_file_id != null)
          formData.set('temp_file_id',this.temp_file_id)
          if(this.editCertificateStatus){
            formData.set('temp_id', this.cert_id) 
          } 
          else{
            formData.set("temp_files", this.cert_file);
          }
          
          ApiService.post(this.previewSlug, formData).then(resp => {
            var byteCharacters = atob(resp.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], { type: 'application/pdf;base64' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.$store.commit(SET_LOADING, false)
          });
      },
      downloadDocument(name, resp, documentdata) {
        let fileURL = window.URL.createObjectURL(new Blob([resp],{type: 'application/pdf'}));
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', name+'.'+documentdata.extension);
        document.body.appendChild(fileLink);
        fileLink.click();           
      },
      async addCertification(){
        if (this.$refs.certificationform.validate()) {
          let formData = new FormData(document.getElementById("certificationform"))
          this.getCoordinates(this.currentPage);
          if(this.cert_meta_data.length == 0){
            this.certificationerror = {'Fields': 'Please drop fields on PDF'}
            return;
          }
  
          let certmetadata = JSON.parse(JSON.stringify( this.cert_meta_data));
          for (var key in certmetadata) {
              certmetadata[key].forEach((data,index) => {
                certmetadata[key][index].positionX = data.positionX*this.pxtomm
                certmetadata[key][index].positionY = data.positionY*this.pxtomm
              })
          }
  
          let font_meta_data= {"font": this.selectedFont, "font-variant": this.fontValues.find(o => o.value === this.selectedFont).variant, "font-size": this.fontsize};
          this.$store.commit(SET_LOADING, true)
          formData.set("temp_meta_data", JSON.stringify(certmetadata));
          formData.set('temp_id', this.temp_id)  
          formData.set("temp_files", this.cert_file);
          formData.set('font_meta_data', JSON.stringify(font_meta_data));
          formData.set('temp_validity', this.temp_validity);
          formData.set('_method','put')
          ApiService.post(this.updateSlug+'/'+this.temp_id, formData).then( resp => {
            if(resp.data.success !== undefined && resp.data.success){
                this.$store.dispatch(this.getData,this.temp_id).then(tempresp=>{
                  if(tempresp.success !== undefined && tempresp.success){
                    this.$store.commit(SET_SNACKBAR, {status: true, message: 'Template added successfully'})
                    this.$store.commit(SET_LOADING, false)
                    this.closeCertificationBox()
                  }
                  else {
                    this.$store.commit(SET_LOADING, false)
                  }
                })
            }
            else{
              this.$store.commit(SET_LOADING, false)
            }
          })
        }
      },
    },
  };